import React, { useState } from 'react';
import ScheduleForm from './ScheduleForm';
import './App.css'; 

// IMPORTANT: Replace this with your actual API Gateway URL
const API_ENDPOINT = 'https://kb4dmknautepnglrroradwuwzm0uwsrk.lambda-url.us-west-1.on.aws/'; 

function App() {
  const [status, setStatus] = useState('ready');
  const [message, setMessage] = useState('');
  
  const handleSubmit = async (payload) => {
    setStatus('loading');
    setMessage('Generating schedule...');
    
    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      
      if (!response.ok) {
        // Handle 4xx or 5xx errors from Lambda
        setStatus('error');
        setMessage(`Error: ${data.message || 'An unknown error occurred.'}`);
        return;
      }
      
      // Success case
      setStatus(data.status); // 'success' or 'warning'
      
      // Call the download logic immediately
      const filename = `Project_Schedule_${new Date().toISOString().slice(0, 10)}.csv`;
      
      // Pass the CSV content and filename to the utility function
      downloadCSV(data.csv, filename); 
      
      let finalMessage = `Schedule generated and downloaded successfully.`;
      if (data.warnings && data.warnings.length > 0) {
          finalMessage += ` WARNINGS: ${data.warnings.join(' ')}`;
      }
      setMessage(finalMessage);

    } catch (error) {
      setStatus('error');
      setMessage(`Network Error: Could not connect to the API. ${error.message}`);
    }
  };

  return (
    <div className="App">
      <header>
        <h1>Oracle Fusion Project Scheduler</h1>
      </header>
      <main>
        <ScheduleForm onSubmit={handleSubmit} isSubmitting={status === 'loading'} />
        <p className={`status-message status-${status}`}>{message}</p>
      </main>
    </div>
  );
}

// Global utility function for downloading CSV
const downloadCSV = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};


export default App;